import React from 'react';

const CheckboxListItem = ({ id, isChecked, item, checkboxText, handleSelection }) => {
  return (
    <div className={id !== 'all' ? 'infinite-checkbox-row' : 'infinite-checkbox-row-all'}>
      <input
        className="hidden-infinite-checkbox"
        type="checkbox"
        id={`checkbox-${id}`}
        name={`checkbox-for-${id}`}
        checked={isChecked}
      />
      <span
        className="actual-visible-checkbox"
        onClick={() => handleSelection(item)}
        onKeyDown={(event) => {
          if (event.code === 'Space' || event.code === 'Enter' || event.which === '32' || event.which === '13') {
            event.preventDefault();
            this.toggleEditing(item);
          }
        }}
        role="checkbox"
        tabIndex="0"
        aria-checked="false"
      />
      <span className="infinite-checkbox-row-text"> {checkboxText}</span>
    </div>
  );
};

export default CheckboxListItem;
